import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "carousel-inner" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "carousel-dots" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "carousel",
    style: _normalizeStyle({ height: _ctx.height })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _ctx.images[_ctx.currentIndex],
        alt: _ctx.alt,
        class: "carousel-img",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click', _ctx.currentIndex)))
      }, null, 8, _hoisted_2)
    ]),
    (_ctx.images.length > 1)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("button", {
            class: "carousel-btn prev",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args)), ["prevent","stop"]))
          }, "‹"),
          _createElementVNode("button", {
            class: "carousel-btn next",
            onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)), ["prevent","stop"]))
          }, "›"),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (_, i) => {
              return (_openBlock(), _createElementBlock("span", {
                key: i,
                class: _normalizeClass(["dot", { active: i === _ctx.currentIndex }]),
                onClick: _withModifiers(($event: any) => (_ctx.currentIndex = i), ["prevent","stop"])
              }, null, 10, _hoisted_4))
            }), 128))
          ])
        ], 64))
      : _createCommentVNode("", true)
  ], 4))
}